package com.ijoin.data.api

import com.ijoin.data.api.ApiClient.addAuthToken
import com.ijoin.data.model.CreateFreeTicketsRequest
import com.ijoin.data.model.PageResponse
import com.ijoin.data.model.Ticket
import io.ktor.client.call.body
import io.ktor.client.request.get
import io.ktor.client.request.parameter
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.contentType

class TicketApi {
    private val client = ApiClient.client
    private val baseUrl = "${ApiClient.getBaseUrl()}/api/tickets"

    suspend fun getUserTickets(): Result<List<Ticket>> {
        return safeApiCall {
            client.get("$baseUrl/user") {
                addAuthToken()
            }
        }.mapCatching { response -> response.body() }
    }

    suspend fun getUpcomingTickets(): Result<List<Ticket>> {
        return safeApiCall {
            client.get("$baseUrl/user/upcoming") {
                addAuthToken()
            }
        }.mapCatching { response -> response.body() }
    }

    suspend fun getFavoriteTickets(): Result<List<Ticket>> {
        return safeApiCall {
            client.get("$baseUrl/user/favorites") {
                addAuthToken()
            }
        }.mapCatching { response -> response.body() }
    }

    suspend fun getTicketById(ticketId: String): Result<Ticket> {
        return safeApiCall {
            client.get("$baseUrl/$ticketId") {
                addAuthToken()
            }
        }.mapCatching { response -> response.body() }
    }

    suspend fun toggleFavorite(ticketId: String): Result<Ticket> {
        return safeApiCall {
            client.post("$baseUrl/$ticketId/favorite") {
                addAuthToken()
            }
        }.mapCatching { response -> response.body() }
    }

    suspend fun getEventTickets(eventId: String, page: Int, size: Int): Result<PageResponse<Ticket?>> {
        return safeApiCall {
            client.get("$baseUrl/event/$eventId") {
                addAuthToken()
                parameter("page", page)
                parameter("size", size)
            }
        }.mapCatching { response -> response.body() }
    }

    suspend fun createFreeTickets(request: CreateFreeTicketsRequest): Result<List<Ticket>> {
        return safeApiCall {
            client.post("$baseUrl/free") {
                addAuthToken()
                contentType(ContentType.Application.Json)
                setBody(request)
            }
        }.mapCatching { response -> response.body() }
    }

    suspend fun getTicketsByBooking(bookingId: Long): Result<List<Ticket>> {
        return safeApiCall {
            client.get("$baseUrl/booking/$bookingId") {
                addAuthToken()
            }
        }.mapCatching { response -> response.body() }
    }

    suspend fun getTicketsByPayment(paymentId: String): Result<List<Ticket>> {
        return safeApiCall {
            client.get("$baseUrl/payment/$paymentId") {
                addAuthToken()
            }
        }.mapCatching { response -> response.body() }
    }

    suspend fun cancelTicket(ticketId: String): Result<Ticket> {
        return safeApiCall {
            client.post("$baseUrl/$ticketId/cancel") {
                addAuthToken()
            }
        }.mapCatching { response -> response.body() }
    }
}
